module.exports = __webpack_public_path__ + "img/ladder_stage_railing_grab.522e30fe.jpg";